import UserText from 'components/Helpers/UserText/UserText';
import { stripHtml } from 'helpers/parsing/stripHtml';
import Head from 'next/head';
import { FaqEntryType, FaqItemType } from 'types/faq';

type FaqAccordionProps = {
    items: FaqItemType[];
};

export const FaqAccordion: FC<FaqAccordionProps> = ({ items }) => {
    if (items.length === 0) {
        return null;
    }

    const faqEntries: FaqEntryType[] = items
        .map((item) => ({
            '@type': 'Question' as const,
            name: item.question.trim(),
            acceptedAnswer: {
                '@type': 'Answer' as const,
                text: stripHtml(item.answer),
            },
        }))
        .filter((item) => item.name !== '' && item.acceptedAnswer.text !== '');

    return (
        <>
            {faqEntries.length > 0 && (
                <Head>
                    <script
                        key="faq-metadata"
                        id="faq-metadata"
                        type="application/ld+json"
                        dangerouslySetInnerHTML={{
                            __html: JSON.stringify({
                                '@context': 'https://schema.org/',
                                '@type': 'FAQPage',
                                mainEntity: faqEntries,
                            }).replace(/</g, '\\u003c'),
                        }}
                    />
                </Head>
            )}
            <div className="grapesjs-text user-text w-full">
                {items.map((item, index) => (
                    <details key={index} className="gjs-accordion faq-item">
                        <summary className="gjs-accordion__heading">
                            <span className="gjs-accordion__icon" />
                            <h4 className="!text-[1.05rem] text-h4 !leading-[1.4rem]" itemProp="name">
                                {item.question}
                            </h4>
                        </summary>
                        <div className="gjs-accordion__content faq-content" itemProp="text">
                            <UserText htmlContent={item.answer} />
                        </div>
                    </details>
                ))}
            </div>
        </>
    );
};
